module.exports = __webpack_public_path__ + "19e65b89cee273a249fba4c09b951b74.eot";


//////////////////
// WEBPACK FOOTER
// ./~/onsenui/css/ionicons/fonts/ionicons.eot
// module id = 300
// module chunks = 1